<template>
  <div>
    <!-- Base Modal - Used for both Initial and Final states -->
    <BaseModal
      ref="baseModal"
      :modal-id="modalId"
      :modal-text="modalText"
      :button-text="buttonText"
      @button-click="handleBaseModalAction"
      v-if="isBaseModalVisible"
    />

    <!-- Job Description Modal -->
    <JobDescriptionModal
      ref="jobModal"
      v-if="isJobModalVisible"
      :currentJob="currentJob"
      :currentIndex="currentJobIndex"
      :totalJobs="jobs.length"
      :loading="loading"
      @next="handleNextJob"
      @scout="openScoutConfirmation"
      @close="handlePopupClose"
    />

    <!-- Scout Confirmation Modal -->
    <ScoutConfirmationModal
      v-if="showScoutConfirmation"
      @confirm="handleScoutConfirm"
      @cancel="handleScoutCancel"
      ref="scoutConfirmModal"
    />
  </div>
</template>

<script>
import Api from "@/config/api";
import BaseModal from "./BaseModal.vue";
import JobDescriptionModal from "./JobDescriptionModal.vue";
import ScoutConfirmationModal from "./ScoutConfirmationModal.vue";
export default {
  name: "ScoutJob",
  components: {
    BaseModal,
    JobDescriptionModal,
    ScoutConfirmationModal,
  },
  data() {
    return {
      // Modal States: 'initial' | 'jobs' | 'final'
      currentState: "initial",

      // Job Data
      jobs: [], // Array of 3 jobs
      currentJobIndex: 0,

      // Modal Visibility
      showScoutConfirmation: false,
      loading: false,
    };
  },
  computed: {
    // Base Modal computations
    isBaseModalVisible() {
      return ["initial", "final"].includes(this.currentState);
    },

    isJobModalVisible() {
      return this.currentState === "jobs";
    },

    modalId() {
      return this.currentState === "initial" ? "careerModal" : "finalModal";
    },

    modalText() {
      return this.currentState === "initial"
        ? "最初にキャリア登録した企業の <br> マッチする求人を閲覧できます。"
        : "マッチする求人閲覧が完了しました。<br> イベント情報や他の求人を確認できます。";
    },

    buttonText() {
      return this.currentState === "initial"
        ? "求人を見る"
        : "次へ（ホームを表示）";
    },

    // Job related computations
    currentJob() {
      return this.jobs[this.currentJobIndex];
    },

    isLastJob() {
      return this.currentJobIndex === this.jobs.length - 1;
    },
  },
  methods: {
    async getTopThreeJobs() {
      try {
        this.loading = true;
        const token = await this.$auth.getToken();
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const jobs = await this.axios({
          method: "get",
          url: Api.url(Api.endpoints.allJobs),
          headers,
        });
        this.jobs = jobs.data.slice(0, 3);
      } catch (err) {
        console.error("Error fetching jobs:", err);
      } finally {
        this.loading = false;
      }
    },
    // Base Modal Actions
    handleBaseModalAction() {
      if (this.currentState === "initial") {
        this.startJobView();
      } else {
        this.closeModal();
      }
    },

    closeModal() {
      this.$refs.baseModal.hide();
      if(this.modalId === 'finalModal') {
        localStorage.setItem('hasViewedScoutPopup', 'true');
      }
      this.$bvModal.hide(this.modalId);
    },

    handlePopupClose() {
      localStorage.setItem('hasViewedScoutPopup', 'true');
    },

    startJobView() {
      this.currentState = "jobs";
      this.$refs.baseModal.hide();
      this.$nextTick(() => {
        this.$refs.jobModal.show();
      });
    },

    // Job Modal Actions
    handleNextJob() {
      if (this.isLastJob) {
        this.showFinalState();
      } else {
        this.currentJobIndex++;
      }
    },

    showFinalState() {
      this.currentState = "final";
    },

    // Scout Confirmation Actions
    openScoutConfirmation() {
      this.showScoutConfirmation = true;
      this.$nextTick(() => {
        this.$refs.scoutConfirmModal.show();
      });
    },

    async handleScoutConfirm() {
      try {
        await this.submitScoutRequest(this.currentJob._id);
        this.showScoutConfirmation = false;
        this.handleNextJob();
      } catch (error) {
        console.error("Scout request failed:", error);
        // Handle error (show error message, etc.)
      }
    },

    handleScoutCancel() {
      this.showScoutConfirmation = false;
      this.$nextTick(() => {
        this.$refs.jobModal.show();
      });
    },

    // API Methods
    async submitScoutRequest(jobId) {
      // Implement your API call here
      try {
        const token = await this.$auth.getToken();
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        await this.axios({
          method: "post",
          url: Api.url(Api.endpoints.addToScout),
          headers,
          data: {
            jobId,
          },
        });
      } catch (err) {
        console.log("Submitting scout request for job:", jobId);
      }
    },
  },
  mounted() {
    // Show initial modal when component mounts
    this.$bvModal.show(this.modalId);
  },
  watch: {
    isJobModalVisible(newValue) {
      if (newValue) {
        this.getTopThreeJobs();
      }
    },
  },
};
</script>
